
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/what-is-electronic-signature",
      function () {
        return require("private-next-pages/signature/what-is-electronic-signature.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/what-is-electronic-signature"])
      });
    }
  